(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9939],{

/***/ 68773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pricing; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ./src/views/Pricing/assets/PricingOgImage.png
var PricingOgImage = __webpack_require__(53861);
var PricingOgImage_default = /*#__PURE__*/__webpack_require__.n(PricingOgImage);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Pricing/LandingPage/components/Hero/Hero.tsx









var copy = {
  heading: "Pricing that scales",
  description: "Find the right plan and add-ons to enable your engineering, marketing, and product teams to power adaptive, personalized customer experiences with good data."
};
var Hero_button = {
  text: "Get a demo",
  url: "/demo/"
};

var Hero = function Hero() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroBase, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h1",
          tag: "h1",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pLarge",
          tag: "p",
          children: copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
            size: "medium",
            variant: "filled",
            color: "primary",
            href: (0,getAbsoluteUrl/* default */.Z)(Hero_button.url, pageConfig),
            onClick: function onClick() {
              return (0,scripts/* trackButtonClick */.kO)({
                buttonText: Hero_button.text,
                targetUrl: Hero_button.url,
                buttonId: "pricing-landing-page-hero-demo"
              });
            },
            children: Hero_button.text
          })
        })]
      })
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e1cw0sjp2"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.mint[10];
}, ";" + ( true ? "" : 0));

var StyledHeroBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e1cw0sjp1"
} : 0)(recipes_Hero/* Wrapper */.im, "{padding-bottom:0px;gap:0;}" + ( true ? "" : 0));

var StyledButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "e1cw0sjp0"
} : 0)("margin-top:24px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{margin-top:0;}" + ( true ? "" : 0));

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/components/Paper/index.ts + 2 modules
var Paper = __webpack_require__(16164);
// EXTERNAL MODULE: ../../libs/matcha/components/Tooltip/index.ts + 2 modules
var Tooltip = __webpack_require__(57210);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
;// CONCATENATED MODULE: ./src/views/Pricing/LandingPage/components/PlansCards/data.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var getCards = function getCards(config) {
  return [{
    title: "Connections",
    excerpt: ["Collect real-time event data from 450+ pre-built sources, including the warehouse, and send unified customer data to your favorite marketing and analytics tools.", "Plans: Free, Team, and Business"],
    button: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(data_StyledButton, {
      color: "primary",
      size: "large",
      variant: "outlined",
      href: (0,getAbsoluteUrl/* default */.Z)("/pricing/connections/", config),
      onClick: function onClick() {
        return (0,scripts/* trackButtonClick */.kO)({
          buttonText: "Learn about Connections plans",
          targetUrl: "/pricing/connections/",
          buttonId: "pricing-landing-page-connections-plan"
        });
      },
      children: "Learn about Connections plans"
    }),
    benefitsHeading: "What you can do with Connections:",
    benefits: [{
      title: "Enable engineering teams to:",
      list: [{
        text: "Collect and unify real-time events with customer data in the warehouse"
      }, {
        text: "Send customer data to 450+ destinations"
      }, {
        text: "Govern data for quality and compliance"
      }]
    }, {
      title: "Optional add-on",
      list: [{
        text: "Advanced data governance",
        tooltip: "Automatically enforce data quality at scale"
      }]
    }]
  }, {
    title: "Customer Data Platform (CDP)",
    excerpt: ["The most complete, extensible, and scalable CDP that enables technical and business users to create unified profiles, build audiences, orchestrate personalized journeys in real-time, and enhance every experience with data from your warehouse.", "Plans: Unify, Unify Plus, and Engage"],
    button: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(data_StyledButton, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/pricing/customer-data-platform/", config),
      onClick: function onClick() {
        return (0,scripts/* trackButtonClick */.kO)({
          buttonText: "Learn about CDP plans",
          targetUrl: "/pricing/customer-data-platform/",
          buttonId: "pricing-landing-page-cdp-plan"
        });
      },
      children: "Learn about CDP plans"
    }),
    benefitsHeading: "Everything in Connections AND:",
    benefits: [{
      title: "Enable engineering teams to:",
      list: [{
        text: "Automatically generate identity-resolved profiles"
      }, {
        text: "Collect and unify real-time events with customer data in the warehouse"
      }, {
        text: "Enrich and activate unified profile data to downstream tools"
      }, {
        text: "Govern data for quality and compliance"
      }]
    }, {
      title: "Enable marketing teams to:",
      list: [{
        text: "Get a complete view of the customer"
      }, {
        text: "Create and manage audiences"
      }, {
        text: "Orchestrate customer journeys and campaigns"
      }, {
        text: "Leverage predictive and generative AI"
      }]
    }, {
      title: "Optional add-on",
      list: [{
        text: "Advanced data governance",
        tooltip: "Automatically enforce data quality at scale"
      }, {
        text: "Audience & profile enrichment ",
        tooltip: "Expand identity-resolved profiles to include all warehouse data"
      }, {
        text: "AI recommended audiences",
        tooltip: "Build more targeted audiences based on AI-powered product recommendations designed to drive conversions"
      }]
    }]
  }];
};

var data_StyledButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "e13sa9780"
} : 0)( true ? {
  name: "1eufnqu",
  styles: "width:100%;margin-bottom:20px"
} : 0);

/* harmony default export */ var data = (getCards);
;// CONCATENATED MODULE: ./src/views/Pricing/LandingPage/components/PlansCards/PlansCards.tsx


function PlansCards_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var PlansCards = function PlansCards() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlansCards_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardColumns, {
          children: data(pageConfig).map(function (card, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPaper, {
              elevation: 3,
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTitle, {
                tag: "h2",
                variant: "h3",
                children: card.title
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: card.excerpt.map(function (text) {
                  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                    variant: "pMedium",
                    children: text
                  }, text);
                })
              }), card.button, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListHeading, {
                variant: "pMedium",
                children: card.benefitsHeading
              }), card.benefits.map(function (benefit) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListSubtitle, {
                    variant: "pMedium",
                    children: benefit.title
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
                    children: benefit.list.map(function (item, index) {
                      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledListItem, {
                        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Benefit, {
                          variant: "pMedium",
                          children: [item.text, item.tooltip && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                            label: item.tooltip,
                            placement: "top",
                            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* InfoIcon */.sz, {
                              color: theme.palette.twilio.gray[40]
                            })
                          })]
                        })
                      }, "benefit-".concat(index));
                    })
                  })]
                }, benefit.title);
              })]
            }, index);
          })
        })
      })
    })
  });
};

var PlansCards_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1yd4sqe9"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.mint[10];
}, ";padding-bottom:40px;" + ( true ? "" : 0));

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1yd4sqe8"
} : 0)("max-width:1280px;", Section/* Wrapper */.im, "{padding-top:0;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{row-gap:40px;}}" + ( true ? "" : 0));

var CardColumns = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1yd4sqe7"
} : 0)("display:grid;gap:32px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{grid-template-columns:repeat(2, 1fr);}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("xl");
}, "{grid-template-columns:416px auto;}" + ( true ? "" : 0));

var StyledPaper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Paper/* default */.Z,  true ? {
  target: "e1yd4sqe6"
} : 0)("display:grid;background-color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.neutrals.white[100];
}, ";padding:0px 24px 24px;grid-template-rows:repeat(6, min-content) 1fr;justify-self:center;", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("lg");
}, "{padding:8px 32px 10px 32px;}" + ( true ? "" : 0));

var StyledTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1yd4sqe5"
} : 0)( true ? {
  name: "1ykowef",
  styles: "margin-bottom:0"
} : 0);

var ListSubtitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1yd4sqe4"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);

var ListHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1yd4sqe3"
} : 0)( true ? {
  name: "16ceglb",
  styles: "font-weight:600"
} : 0);

var List = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e1yd4sqe2"
} : 0)("margin-top:8px;margin-bottom:24px;padding-left:24px;", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.up("lg");
}, "{margin-bottom:18px;}" + ( true ? "" : 0));

var StyledListItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e1yd4sqe1"
} : 0)( true ? {
  name: "so996i",
  styles: "list-style-image:url(\"data:image/svg+xml;charset=UTF-8,%3csvg width='12' height='9' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.045.667a.91.91 0 0 1 .025 1.305L5.031 8.126a.95.95 0 0 1-1.356 0L.93 5.33a.91.91 0 0 1 .025-1.305.954.954 0 0 1 1.331.025l2.067 2.106L9.714.692a.954.954 0 0 1 1.33-.025Z' fill='%23121C2D'/%3e%3c/svg%3e \");font-weight:400;padding:0 0 8px 6px"
} : 0);

var Benefit = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1yd4sqe0"
} : 0)( true ? {
  name: "wgm2x7",
  styles: "margin:0;display:flex;gap:8px"
} : 0);

/* harmony default export */ var PlansCards_PlansCards = (PlansCards);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/index.ts + 1 modules
var LogoCarousel = __webpack_require__(6087);
;// CONCATENATED MODULE: ./src/views/Pricing/LandingPage/components/LogoCarousel/LogoCarousel.tsx


function LogoCarousel_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var LogoCarousel_LogoCarousel = function LogoCarousel() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSection, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLogoCarousel, {})
  });
};

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1sjagcw1"
} : 0)(Section/* Wrapper */.im, "{gap:0;padding-bottom:0;}" + ( true ? "" : 0));

var StyledLogoCarousel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(LogoCarousel["default"],  true ? {
  target: "e1sjagcw0"
} : 0)( true ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : 0);

/* harmony default export */ var components_LogoCarousel_LogoCarousel = (LogoCarousel_LogoCarousel);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ./src/views/Pricing/LandingPage/components/ArtificialIntelligence/assets/ArtificialIntelligence@2x.png
var ArtificialIntelligence_2x = __webpack_require__(39723);
var ArtificialIntelligence_2x_default = /*#__PURE__*/__webpack_require__.n(ArtificialIntelligence_2x);
// EXTERNAL MODULE: ./src/views/Pricing/LandingPage/components/ArtificialIntelligence/assets/ArtificialIntelligence.webp
var assets_ArtificialIntelligence = __webpack_require__(89888);
var ArtificialIntelligence_default = /*#__PURE__*/__webpack_require__.n(assets_ArtificialIntelligence);
// EXTERNAL MODULE: ./src/views/Pricing/LandingPage/components/ArtificialIntelligence/assets/ArtificialIntelligence@2x.webp
var assets_ArtificialIntelligence_2x = __webpack_require__(21617);
var assets_ArtificialIntelligence_2x_default = /*#__PURE__*/__webpack_require__.n(assets_ArtificialIntelligence_2x);
;// CONCATENATED MODULE: ./src/views/Pricing/LandingPage/components/ArtificialIntelligence/ArtificialIntelligence.tsx


function ArtificialIntelligence_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















var ArtificialIntelligence_copy = {
  heading: "Artificial Intelligence",
  description: "Segment makes it easier than ever to understand, predict, and generate 1:1 customer engagement in real time and at scale."
};
var ArtificialIntelligence_data = [{
  heading: "Predictive AI",
  description: ["Predict customer behavior using a no-code builder to power more timely, targeted, and precise personalized experiences on every channel.", "Available with Unify Plus and Engage plans."]
}, {
  heading: "Generative AI for Marketers",
  description: ["Create and launch complex audiences in minutes with a simple text prompt.", "Available with Engage plans."]
}, {
  heading: "Generative AI for Developers",
  description: ["Generate and optimize code in minutes from natural language prompts (with rETL support for Functions) to create custom integrations and capabilities faster than ever.", "Available with all CDP and Connections Business plans."]
}];
var demoButton = {
  text: "Get a demo",
  url: "/demo/"
};
var learnMoreButton = {
  text: "Learn more about Customer AI",
  url: "/solutions/ai/"
};

var ArtificialIntelligence = function ArtificialIntelligence() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArtificialIntelligence_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ArtificialIntelligence_StyledSection, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCopyTextBase, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h2",
            children: ArtificialIntelligence_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pLarge",
            tag: "p",
            children: ArtificialIntelligence_copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnsWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ColumnTrack/* default */.Z, {
            columns: 1,
            overrides: {
              md: 2
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, {
              children: ArtificialIntelligence_data.map(function (_ref) {
                var heading = _ref.heading,
                    description = _ref.description;
                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
                  alignment: "left",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                      children: heading
                    }), description.map(function (text) {
                      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                        variant: "pMedium",
                        children: text
                      }, text);
                    })]
                  })
                }, heading);
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                  type: "image/webp",
                  srcSet: "".concat((ArtificialIntelligence_default()), ", ").concat((assets_ArtificialIntelligence_2x_default()), " 2x")
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
                  width: "935",
                  height: "771",
                  src: (ArtificialIntelligence_2x_default()),
                  alt: "Illustration: ".concat(ArtificialIntelligence_copy.heading),
                  loading: "lazy"
                })]
              })
            })]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ButtonsWrapper, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            size: "medium",
            variant: "filled",
            href: (0,getAbsoluteUrl/* default */.Z)(demoButton.url, pageConfig),
            onClick: function onClick() {
              return (0,scripts/* trackButtonClick */.kO)({
                buttonText: demoButton.text,
                targetUrl: demoButton.url,
                buttonId: "pricing-landing-page-ai-section-demo"
              });
            },
            children: demoButton.text
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            size: "medium",
            variant: "outlined",
            href: (0,getAbsoluteUrl/* default */.Z)(learnMoreButton.url, pageConfig),
            onClick: function onClick() {
              return (0,scripts/* trackButtonClick */.kO)({
                buttonText: learnMoreButton.text,
                targetUrl: learnMoreButton.url,
                buttonId: "pricing-landing-page-ai-section-learn-more"
              });
            },
            children: learnMoreButton.text
          })]
        })]
      })]
    })
  });
};

var ArtificialIntelligence_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10a9v2y6"
} : 0)( true ? "" : 0);

var ArtificialIntelligence_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e10a9v2y5"
} : 0)("padding-top:80px;", Section/* Wrapper */.im, "{gap:0;}" + ( true ? "" : 0));

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "e10a9v2y4"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("sm");
}, "{text-align:left;}" + ( true ? "" : 0));

var ColumnsWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10a9v2y3"
} : 0)( true ? {
  name: "1bkpu5b",
  styles: "margin-top:30px"
} : 0);

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10a9v2y2"
} : 0)( true ? {
  name: "yirxjq",
  styles: "display:grid;align-content:center;gap:24px;justify-self:center"
} : 0);

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e10a9v2y1"
} : 0)( true ? {
  name: "13fk291",
  styles: "width:100%;max-width:620px"
} : 0);

var ButtonsWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10a9v2y0"
} : 0)("margin-top:44px;display:flex;gap:24px;align-items:center;justify-content:center;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{flex-direction:column;}" + ( true ? "" : 0));

/* harmony default export */ var ArtificialIntelligence_ArtificialIntelligence = (ArtificialIntelligence);
// EXTERNAL MODULE: ../../node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(24330);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Accordion/index.ts + 26 modules
var Accordion = __webpack_require__(83914);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/index.ts
var RichText = __webpack_require__(47756);
// EXTERNAL MODULE: ../../libs/utils/useActiveState/index.ts + 1 modules
var useActiveState = __webpack_require__(74864);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
;// CONCATENATED MODULE: ./src/views/Pricing/LandingPage/components/Faq/data.ts

var faqs = [{
  title: "Is there a free trial of the paid plans?",
  description: {
    content: [{
      data: {},
      content: [{
        data: {},
        content: [{
          data: {},
          marks: [],
          value: "Yes! There is a 14-day free trial for Connections. Learn more ",
          nodeType: "text"
        }, {
          data: {
            uri: "/pricing/connections/"
          },
          content: [{
            data: {},
            marks: [],
            value: "here",
            nodeType: "text"
          }],
          nodeType: dist.INLINES.HYPERLINK
        }, {
          data: {},
          marks: [],
          value: ". For CDP plans, please ",
          nodeType: "text"
        }, {
          data: {
            uri: "/demo/"
          },
          content: [{
            data: {},
            marks: [],
            value: "contact us",
            nodeType: "text"
          }, {
            data: {},
            marks: [],
            value: ".",
            nodeType: "text"
          }],
          nodeType: dist.INLINES.HYPERLINK
        }],
        nodeType: dist.BLOCKS.PARAGRAPH
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}, {
  title: "Do I need to purchase a Connections and a CDP plan?",
  description: {
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: "No! Connections capabilities are included in all Customer Data Platform (CDP) plans. For teams only focused on collecting and sending customer data to downstream destinations, Connections plans are a great place to start and can be upgraded to a CDP plan when your team is ready.",
        nodeType: "text"
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}, {
  title: "Are the artificial intelligence capabilities included in plans?",
  description: {
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: "Predictive and Generative AI capabilities are available in select Customer Data Platform (CDP) plans. Recommended Audiences are available as an add-on to Engage plans. ",
        nodeType: "text"
      }, {
        data: {
          uri: "/pricing/customer-data-platform/"
        },
        content: [{
          data: {},
          marks: [],
          value: "Learn more",
          nodeType: "text"
        }],
        nodeType: dist.INLINES.HYPERLINK
      }, {
        data: {},
        marks: [],
        value: " about CDP plans.",
        nodeType: "text"
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}, {
  title: "How can I buy Protocols, Unify or Twilio Engage?",
  description: {
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: "Protocols is included in all Customer Data Platform (CDP) plans and an optional add-on for Connections Business plans. Unify and Twilio Engage are available CDP plans. ",
        nodeType: "text"
      }, {
        data: {
          uri: "/pricing/customer-data-platform/"
        },
        content: [{
          data: {},
          marks: [],
          value: "Learn more",
          nodeType: "text"
        }],
        nodeType: dist.INLINES.HYPERLINK
      }, {
        data: {},
        marks: [],
        value: " about CDP plans, or ",
        nodeType: "text"
      }, {
        data: {
          uri: "/demo/"
        },
        content: [{
          data: {},
          marks: [],
          value: "contact us",
          nodeType: "text"
        }],
        nodeType: dist.INLINES.HYPERLINK
      }, {
        data: {},
        marks: [],
        value: " to determine which plan is best for you.",
        nodeType: "text"
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}];
;// CONCATENATED MODULE: ./src/views/Pricing/LandingPage/components/Faq/FAQ.tsx


function FAQ_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var FAQ_data = {
  heading: "FAQs",
  faqs: faqs
};

var FAQ = function FAQ() {
  var items = new Array(FAQ_data.faqs.length).fill(false);

  var _useActiveState = (0,useActiveState/* useActiveState */.z)(items, {
    allowMultipleActive: true
  }),
      activeItems = _useActiveState.activeItems,
      toggle = _useActiveState.toggle;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FAQ_StyledSectionBase, {
    variant: "centered",
    id: "faq",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        centered: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          dangerouslySetInnerHTML: {
            __html: sanitize_html_default()(FAQ_data.heading)
          }
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionContents, {
      children: activeItems.map(function (active, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* Header */.h4, {
            onClick: function onClick() {
              return toggle(index);
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* TitleWrapper */.$t, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Title */.Dx, {
                opened: active,
                tag: "h3",
                children: FAQ_data.faqs[index].title
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Icon */.JO, {
              opened: active
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Body */.uT, {
            children: active && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* ContentWrapper */.vs, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Text */.xv, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
                  data: FAQ_data.faqs[index].description
                })
              })
            })
          })]
        }, "item-".concat(index));
      })
    })]
  });
};

var FAQ_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e6zkz301"
} : 0)("overflow:inherit;", Section/* Wrapper */.im, "{justify-content:stretch;}" + ( true ? "" : 0));

var StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e6zkz300"
} : 0)( true ? {
  name: "1h9b9cv",
  styles: "max-width:844px;width:100%"
} : 0);

/* harmony default export */ var Faq_FAQ = (FAQ);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ./src/views/Pricing/LandingPage/components/GettingStarted/GettingStarted.tsx


function GettingStarted_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var GettingStarted_copy = {
  heading: "Getting started is easy",
  description: "Whether your team is personalizing experiences in real time or building foundational data pipelines, Segment enables advanced use cases and customizations with low-code solutions."
};

var GettingStarted = function GettingStarted() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          children: GettingStarted_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: GettingStarted_copy.description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GettingStarted_Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "medium",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
          onClick: function onClick() {
            return (0,scripts/* trackButtonClick */.kO)({
              buttonText: "Get a CDP demo",
              targetUrl: "/demo/",
              buttonId: "pricing-landing-page-get-started-section-demo"
            });
          },
          children: "Get a CDP demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          iconEnd: Common/* ChevronRightIcon */.XC,
          href: (0,getAbsoluteUrl/* default */.Z)("/signup/", pageConfig),
          onClick: function onClick() {
            return (0,scripts/* trackButtonClick */.kO)({
              buttonText: "Start with Connections for free",
              targetUrl: "/pricing/connections/",
              buttonId: "pricing-landing-page-get-started-section-connections"
            });
          },
          children: "Start with Connections for free"
        })]
      })]
    })
  });
};

var GettingStarted_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "enar04b2"
} : 0)( true ? {
  name: "9pr6yz",
  styles: "padding-top:40px;padding-bottom:80px;max-width:900px;margin:0 auto"
} : 0);

var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "enar04b1"
} : 0)( true ? {
  name: "6o84rx",
  styles: "display:grid;justify-content:center;row-gap:40px;padding:0 20px"
} : 0);

var GettingStarted_Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "enar04b0"
} : 0)( true ? {
  name: "e49cvm",
  styles: "display:flex;flex-direction:column;align-items:center;margin:0 auto;gap:18px"
} : 0);

/* harmony default export */ var GettingStarted_GettingStarted = (GettingStarted);
;// CONCATENATED MODULE: ./src/views/Pricing/LandingPage/Pricing.tsx
















var Pricing = function Pricing() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Twilio Segment Plans & Pricing | Twilio Segment",
      pageDescription: "Discover options to enable your organization to create unified profiles, build audiences, & orchestrate personalized journeys. Compare pricing plans from Twilio Segment",
      pageOG: (PricingOgImage_default()),
      themeColor: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlansCards_PlansCards, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_LogoCarousel_LogoCarousel, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArtificialIntelligence_ArtificialIntelligence, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Faq_FAQ, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted_GettingStarted, {})]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1vndawx0"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var LandingPage_Pricing = (Pricing);
;// CONCATENATED MODULE: ./src/pages/pricing/index.tsx



var pricing_Pricing = function Pricing() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LandingPage_Pricing, {});
};

/* harmony default export */ var pricing = (pricing_Pricing);

/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 53938:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing",
      function () {
        return __webpack_require__(68773);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39723:
/***/ (function(module) {

module.exports = "/_next/static/images/ArtificialIntelligence@2x-432c073aae4d7b4f6c715bc26f609dc7.png";

/***/ }),

/***/ 89888:
/***/ (function(module) {

module.exports = "/_next/static/images/ArtificialIntelligence-5bb62df48dfb1408a15f41ffefa62f9c.webp";

/***/ }),

/***/ 21617:
/***/ (function(module) {

module.exports = "/_next/static/images/ArtificialIntelligence@2x-432c073aae4d7b4f6c715bc26f609dc7.webp";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,8834,4330,1382,4136,8392,2073,7096,2429,7303,4488,948,3996,8187,8726,7960,6012,3922,8536,3379,5062,1668,9774,2888,179], function() { return __webpack_exec__(53938); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);